import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./shared";
import { IMG } from "../../lib/assets";

export const FullBleed = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section
      ref={ref}
      className="relative w-full overflow-hidden bg-[#0B0B0C]"
      data-testid="full-bleed-section"
    >
      <div className="relative h-[72vh] min-h-[460px] sm:h-[80vh] sm:min-h-[560px] lg:h-[88vh]">
        <motion.img
          src={IMG.fullBleedEnergy}
          alt="A woman in headphones checking her SOURCECODED read on her phone, lit in orange and violet"
          loading="lazy"
          decoding="async"
          style={{ y }}
          className="absolute inset-0 w-full h-[112%] -top-[6%] object-cover object-center"
          data-testid="full-bleed-image"
        />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(to top, rgba(11,11,12,0.92) 0%, rgba(11,11,12,0.55) 26%, rgba(11,11,12,0.08) 55%, rgba(11,11,12,0.35) 100%)",
          }}
        />
        <div className="absolute inset-x-0 bottom-0">
          <div className="mx-auto max-w-6xl px-5 sm:px-8 pb-10 sm:pb-16">
            <Reveal>
              <p className="eyebrow mb-5 !text-[#F2F0EB]" data-testid="full-bleed-eyebrow">
                &#9679; Your window
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                className="h-heavy text-[34px] sm:text-6xl lg:text-7xl leading-[0.95] max-w-3xl"
                data-testid="full-bleed-headline"
              >
                Know the hour.
                <br />
                <span className="text-[#FF4D0A]">Then make the call.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p
                className="mt-6 font-mono-brand text-[10px] sm:text-[11px] tracking-[0.2em] uppercase text-[#9DA1A8]"
                data-testid="full-bleed-mono"
              >
                One read every morning &middot; Before the day decides for you
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
